import { render, staticRenderFns } from "./customerScale.vue?vue&type=template&id=b0b35878&scoped=true"
import script from "./customerScale.vue?vue&type=script&lang=js"
export * from "./customerScale.vue?vue&type=script&lang=js"
import style0 from "./customerScale.vue?vue&type=style&index=0&id=b0b35878&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b35878",
  null
  
)

export default component.exports